import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { difference } from 'lodash';
import { FILTER_CONSTANTS } from 'src/constants/constants';
import type { RootState } from '../Store';

// Define a interface for the slice state

// Define the initial state using that type
const initialState: BusFilterStateProps = {
  filters: {
    chooseClass: -1,
    busType: '',
    hourOfDeparture: FILTER_CONSTANTS.DEFAULT_DURATION,
    hourOfArrival: FILTER_CONSTANTS.DEFAULT_DURATION,
    priceRank: FILTER_CONSTANTS.DEFAULT_PRICE_RANK,
    chooseBusService: [],
  },
  filterCount: 0,
};

const BusFilterSlice = createSlice({
  name: 'busFilter',
  initialState,
  reducers: {
    busFilterAction: (state, action: PayloadAction<BusFilterProps>) => {
      let filterCount = 0;

      if (action.payload.chooseClass !== -1) filterCount += 1;
      if (action.payload.busType !== '') filterCount += 1;
      if (
        action.payload.hourOfDeparture &&
        difference(action.payload.hourOfDeparture, FILTER_CONSTANTS.DEFAULT_DURATION).length > 0
      )
        filterCount += 1;
      if (
        action.payload.hourOfArrival &&
        difference(action.payload.hourOfArrival, FILTER_CONSTANTS.DEFAULT_DURATION).length > 0
      )
        filterCount += 1;
      if (
        action.payload.priceRank &&
        difference(action.payload.priceRank, FILTER_CONSTANTS.DEFAULT_PRICE_RANK).length > 0
      )
        filterCount += 1;
      if (action.payload.chooseBusService && action.payload.chooseBusService.length > 0) {
        filterCount += action.payload.chooseBusService.length;
      }

      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        filterCount,
      };
    },
    clearBusFilterAction: (state, action: PayloadAction<keyof BusFilterProps | 'CLEAR_ALL'>) => {
      if (action.payload === 'CLEAR_ALL') return initialState;

      return {
        ...state,
        filters: { ...state.filters, [action.payload]: initialState.filters[action.payload] },
        filterCount: state.filterCount - 1,
      };
    },
    clearBusServiceFilterAction: (state, action: PayloadAction<{ chooseBusService: any }>) => {
      return {
        ...state,
        filters: { ...state.filters, chooseBusService: action.payload.chooseBusService },
        filterCount: state.filterCount - 1,
      };
    },
  },
});

export const { busFilterAction, clearBusFilterAction, clearBusServiceFilterAction } = BusFilterSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const busFilterSelector = (state: RootState) => state.busFilter.filters;
export const busFilterCounterSelector = (state: RootState) => state.busFilter.filterCount;

export default BusFilterSlice.reducer;
